import { GzDeleteEntityWebComponent } from './component/GzDeleteEntityWebComponent';

export { GzDeleteEntityWebComponent };
